export default [
  { label: 'High', value: 'high', color: '#FF0000' },
  { label: 'Medium', value: 'medium', color: '#FFAE00' },
  { label: 'Low', value: 'low', color: '#2BFF00' }
]
